import { FC } from 'react';

import {
    FALLBACK_MAGNIFYING_GLASS_FRAME_HEIGHT,
    FALLBACK_MAGNIFYING_GLASS_FRAME_WIDTH,
    MAGNIFYING_GLASS_FRAME_ID,
    ZOOM_FACTOR,
} from './constants';
import { Spotlight } from './Spotlight.styles';
import { useCursorPosition } from './useCursorPosition';
import { useZoomControls } from './ZoomContext';

export const SpotlightCursor: FC = () => {
    const { x, y, isCursorHovering, imageToZoomSrc, imageToZoomDimensions } = useZoomControls();

    const magnifyingGlassFrame = document.getElementById(MAGNIFYING_GLASS_FRAME_ID);
    const frameWidth = magnifyingGlassFrame?.clientWidth || FALLBACK_MAGNIFYING_GLASS_FRAME_WIDTH;
    const frameHeight = magnifyingGlassFrame?.clientHeight || FALLBACK_MAGNIFYING_GLASS_FRAME_HEIGHT;

    const spotlightWidth = frameWidth / ZOOM_FACTOR;
    const spotlightHeight = frameHeight / ZOOM_FACTOR;

    const correctionX = spotlightWidth / 2;
    const correctionY = spotlightHeight / 2;

    const { pointerX, pointerY } = useCursorPosition(spotlightWidth / 2, spotlightHeight / 2);

    return (
        <Spotlight
            $isEnabled={isCursorHovering}
            $src={imageToZoomSrc}
            style={{
                left: pointerX,
                top: pointerY,
                backgroundPosition: `${-(x || 0) + correctionX}px ${-(y || 0) + correctionY}px`,
                backgroundSize: `${imageToZoomDimensions.width}px ${imageToZoomDimensions.height}px`,
                width: spotlightWidth,
                height: spotlightHeight,
            }}
        />
    );
};
